import IOTServices from "@/api/IOTServices";
import router from '@/router/index';

const state = {
    loader: false,
    resultset: [],
    headerinfo: [],
    parametersinfo: [],
    bodyinfo: [],
    initialData: {},
    newDevice: {}
}
const getters = {
    getDeviceTypes: (state, getters, rootState, rootGetters) => rootGetters.getDeviceTypes,
    getIOTServices: (state, getters, rootState, rootGetters) => rootGetters.getIOTServices ?  rootGetters.getIOTServices : [],
    getTenants: (state, getters, rootState, rootGetters) => rootGetters.getTenants,
    getEditDevice: state => state.newDevice,
};

const actions = {
    async getIOTServices({ commit,state }) {
        state.loader = true;
        const response = await IOTServices.getIOTServices();
        state.loader=false
        commit('get', response.data.result)
    },
    async getInitialData({commit, state}) {
        state.loader=true
        const response = await IOTServices.getInitialData();
        state.loader=false
        commit('getInitialData', response.data)
    },
    async getDevice({ commit,state, rootState }) {
        state.loader=true
        let id = rootState.selectedFacility ? rootState.selectedFacility.id : 0
        const response = await IOTServices.getDevice(id);
        state.loader=false
        commit('get', response.data.result)     
    },
    async addDevice({ commit, rootState}, device) {
        let id = rootState.selectedFacility ? rootState.selectedFacility.id : 0
        device.facilityID = id;
        const response = await IOTServices.addDevice(device);
        if (response.data.status) {
            commit('addDevice', response.data.result, { root: true });
        } 
        return response.data;
    },
    async editDevice({ commit }, device) {
        const response = await IOTServices.getIOTById(device)
        commit('edit', response.data.result)
         //commit('edit', device)
    },
    async updateDevice({ commit }, device) {
        await IOTServices.updateDevice(state.editId, device);
        commit('updateDevice', device);   
    },

    async deleteIOTDevice({ commit }, device) {
        await IOTServices.deleteIOTDevice(device.id);
        commit('removeIOTDevice', device);
    },
}
const mutations = {
    get(state, data) {
        state.resultset = data;
        state.filteredDevices = data;
    },
    addHeader(state, product) {
        state.headerinfo.push(product);
    },
    getInitialData(state, data) {
        state.initialData = data;
    },
     edit(state, actor) {
        state.editId = actor.id
        state.newDevice = actor
        router.push({ name: "iotAddUpdate", params: { add: false } });
    },
    removeIOTDevice(state,removeId){
        const index = state.resultset.map(item =>item.id).indexOf(removeId.id)
            //findIndex((d) => d.id === deviceId);
        state.resultset.splice(index, 1);
    },

    updateDevice(state, userData) {
        const index = state.resultset.map(item => item.id).indexOf(userData.id)
        state.resultset[index] = userData;
    },

     employeeError(state, data) {
        data.map(data => {
            if (data.error) {
                state.EmployeeErrors.push({ error: data.error, email: data.notAddedEmployee.emailID, empID: data.notAddedEmployee.employeeCode, empName: data.notAddedEmployee.name, })
            }
            else {
                state.EmployeeErrors.push({ error: data.errorMessage, cell: data.cell })
            }
        })
    },
    downloadData(){

    },
    cancel(state) {
        state.metadata = {}
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}